import React from 'react';
import { styles } from './adminStyles';
import UserManagementTable from '../../../components/UserManagementTable';

const UserManagement = ({ handleOpenUserReport, onOpenSummaryReport }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div style={{...styles.card, marginBottom: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div>
                <h2 style={{margin: '0 0 4px 0', ...styles.h2}}>Registered Farmers</h2>
                <p style={{margin: 0, ...styles.textMuted, fontSize: '0.85rem'}}>Full roster with overall bid history and land-use summary.</p>
            </div>
            <button onClick={onOpenSummaryReport} style={styles.btnPrimary}>Farmer Summary Report</button>
        </div>
        <div style={{...styles.card, minHeight: '200px', marginBottom: 0}}>
            <UserManagementTable onRunReport={handleOpenUserReport} />
        </div>
    </div>
  );
};

export default UserManagement;
